import { Button } from "@components/button";
import { PlusIcon } from "@components/icon";
import { ISmartFastEntryListProps } from "@components/smart/smartFastEntryList";
import { ActionType, addEmptyLineItem } from "@components/smart/smartFastEntryList/SmartFastEntryList.utils";
import { IFormGroupDef } from "@components/smart/smartFormGroup/SmartFormGroup";
import BindingContext from "@odata/BindingContext";
import { getNewItemsMaxId } from "@odata/Data.utils";
import React from "react";

import { IconSize, TextAlign } from "../../enums";
import { ButtonGroupStyled } from "./VirtualizedForm.styles";
import { TSmartVirtualizedFormStorage } from "./VirtualizedForm.utils";


interface IFormGroupFooterProps extends Pick<ISmartFastEntryListProps, "onAction"> {
    storage: TSmartVirtualizedFormStorage;
    bindingContext: BindingContext;
    def: IFormGroupDef;
}

interface IState {
    isDialogOpened: boolean;
}

export default class VirtualizedFormLineItemsAdd extends React.PureComponent<IFormGroupFooterProps, IState> {

    handleAdd = (): void => {
        const { storage, def, bindingContext } = this.props;
        const lineItemsBc = bindingContext.navigate(def.lineItems.collection);
        const items = storage.getValue(lineItemsBc) ?? [];
        const newItemsMax = getNewItemsMaxId(items);
        const newItem = addEmptyLineItem({
            storage: this.props.storage,
            bindingContext: lineItemsBc,
            newItemsCount: newItemsMax + 1,
            index: items.length + 1,
            order: def.lineItems.order,
            columns: def.lineItems.columns,
            context: storage.context
        });
        this.props.onAction({
            bindingContext: lineItemsBc,
            actionType: ActionType.Add,
            groupId: def.id,
            items: [...items, newItem],
            affectedItems: [newItem]
        });
    };

    render() {
        const { storage } = this.props;

        return (
            <ButtonGroupStyled align={TextAlign.Center}>
                <Button hotspotId={"fastEntryAdd"}
                        icon={<PlusIcon width={IconSize.S} />}
                        isTransparent={true}
                        onClick={this.handleAdd}>
                    {storage.t("Common:General.AddNext")}
                </Button>
            </ButtonGroupStyled>
        );
    }
}
